import { createFileRoute } from '@tanstack/react-router'
import { CustomerGroupsPage } from '@/pages/customer-groups'

export const Route = createFileRoute('/_authenticated/customers/')({
  staticData: { title: 'Customers' },
  component: CustomerGroupsPage,
})
